  document.addEventListener('click', function (event) {
  if (event.target.matches('dialog[data-search-dialog], dialog[data-menu-dialog]')) {
    event.target.close();
    return;
  }

  var searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    var header = searchToggle.closest('.site-header');
    var searchDialog = header && header.querySelector('[data-search-dialog]');
    if (searchDialog && typeof searchDialog.showModal === 'function') {
      searchDialog.showModal();
      var input = searchDialog.querySelector('input[type="search"]');
      if (input) input.focus();
    }
    return;
  }

  if (event.target.closest('[data-search-close]')) {
    var openSearch = event.target.closest('dialog');
    if (openSearch) openSearch.close();
    return;
  }

  var menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    var headerEl = menuToggle.closest('.site-header');
    var menuDialog = headerEl && headerEl.querySelector('[data-menu-dialog]');
    if (menuDialog && typeof menuDialog.showModal === 'function') {
      menuDialog.showModal();
    }
    return;
  }

  if (event.target.closest('[data-menu-close]')) {
    var openMenu = event.target.closest('dialog');
    if (openMenu) openMenu.close();
  }
});

// --------------------------------------------------------------------
// Predictive search — real Shopify results only (routes.predictive_
// search_url), no invented/AI answers. Debounced fetch with stale-
// request cancellation, full keyboard support, active-result
// highlight. Renders products (thumbnail + price) first, then
// collections / pages / articles, then a "voir tous les résultats"
// link to the real search results page.
// --------------------------------------------------------------------
(function () {
  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;

  document.querySelectorAll('[data-predictive-search-form]').forEach(function (form) {
    var input = form.querySelector('[data-predictive-search-input]');
    var dialog = form.closest('dialog');
    var resultsEl = dialog && dialog.querySelector('[data-predictive-search-results]');
    if (!input || !resultsEl) return;

    var predictiveUrl = form.getAttribute('data-predictive-search-url');
    var searchUrl = form.getAttribute('data-search-url');
    var debounceTimer = null;
    var activeController = null;
    var lastTerm = '';

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function closeResults() {
      resultsEl.innerHTML = '';
      resultsEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    // Catalogue restreint : données fournies par le thème (réglage
    // « Catalogue visible »). Si présentes, seuls ces produits sont
    // proposés, et seules les collections qui les contiennent.
    var catalogEl = document.querySelector('script[data-catalog-allowed]');
    var catalog = null;
    if (catalogEl) {
      try { catalog = JSON.parse(catalogEl.textContent); } catch (e) { catalog = null; }
    }

    function normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[’'\-]/g, ' ');
    }

    function catalogProductsFor(term) {
      var words = normalize(term).split(/\s+/).filter(Boolean);
      if (!words.length) return [];
      return (catalog.products || []).filter(function (product) {
        var haystack = normalize(product.search + ' ' + product.title);
        return words.every(function (word) { return haystack.indexOf(word) !== -1; });
      });
    }

    function renderResults(data, term) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      if (catalog) {
        products = catalogProductsFor(term);
        collections = collections.filter(function (item) {
          return (catalog.collections || []).indexOf(item.handle) !== -1;
        });
      }
      var pages = results.pages || [];
      var articles = results.articles || [];

      var hasAny = products.length || collections.length || pages.length || articles.length;

      if (!hasAny) {
        resultsEl.innerHTML =
          '<p class="site-header__search-empty">Aucun résultat pour « ' + escapeHtml(term) + ' ».</p>';
        resultsEl.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      var html = '';

      if (products.length) {
        html += '<div class="site-header__search-group" data-search-group>';
        html += '<p class="site-header__search-group-label">Produits</p>';
        products.forEach(function (product) {
          var image = product.featured_image && product.featured_image.url;
          html +=
            '<a href="' + product.url + '" class="site-header__search-result" role="option" data-search-result>' +
            '<span class="site-header__search-result-media">' +
            (image
              ? '<img src="' + image + '" alt="" loading="lazy" width="42" height="42">'
              : '') +
            '</span>' +
            '<span class="site-header__search-result-body">' +
            '<span class="site-header__search-result-title">' + escapeHtml(product.title) + '</span>' +
            '<span class="site-header__search-result-price">' + (product.price || '') + '</span>' +
            '</span>' +
            '</a>';
        });
        html += '</div>';
      }

      var others = []
        .concat(collections.map(function (item) { return { item: item, label: 'Collection' }; }))
        .concat(pages.map(function (item) { return { item: item, label: 'Page' }; }))
        .concat(articles.map(function (item) { return { item: item, label: 'Article' }; }));

      if (others.length) {
        html += '<div class="site-header__search-group" data-search-group>';
        html += '<p class="site-header__search-group-label">Collections, pages &amp; articles</p>';
        others.forEach(function (entry) {
          html +=
            '<a href="' + entry.item.url + '" class="site-header__search-result" role="option" data-search-result>' +
            '<span class="site-header__search-result-body">' +
            '<span class="site-header__search-result-title">' + escapeHtml(entry.item.title) + '</span>' +
            '<span class="site-header__search-result-price">' + entry.label + '</span>' +
            '</span>' +
            '</a>';
        });
        html += '</div>';
      }

      html +=
        '<a href="' + searchUrl + '?q=' + encodeURIComponent(term) + '" class="site-header__search-viewall">' +
        'Voir tous les résultats' +
        '</a>';

      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function runSearch(term) {
      if (activeController) activeController.abort();
      activeController = new AbortController();

      var url =
        predictiveUrl +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: activeController.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data) return;
          renderResults(data, term);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      lastTerm = term;

      if (debounceTimer) clearTimeout(debounceTimer);

      if (term.length < MIN_CHARS) {
        if (activeController) activeController.abort();
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        if (input.value.trim() === term) runSearch(term);
      }, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (event) {
      var options = resultsEl.querySelectorAll('[data-search-result]');
      if (!options.length) return;

      var current = resultsEl.querySelector('[data-search-result].is-active');
      var index = current ? Array.prototype.indexOf.call(options, current) : -1;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (current) current.classList.remove('is-active');
        index = (index + 1) % options.length;
        options[index].classList.add('is-active');
        options[index].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (current) current.classList.remove('is-active');
        index = index <= 0 ? options.length - 1 : index - 1;
        options[index].classList.add('is-active');
        options[index].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter') {
        if (current) {
          event.preventDefault();
          window.location.href = current.getAttribute('href');
        }
        // Otherwise let the form submit natively to the real search page.
      } else if (event.key === 'Escape') {
        var openDialog = event.target.closest('dialog');
        if (openDialog) openDialog.close();
      }
    });

    dialog &&
      dialog.addEventListener('close', function () {
        input.value = '';
        closeResults();
        if (activeController) activeController.abort();
      });
  });
})();